import React, { useCallback, useEffect, useState } from 'react';
import * as Styles from '../style';
import { Icon } from 'semantic-ui-react';
import { H4, P } from 'components/reusable-css';
import { useTranslation } from 'react-i18next';
import SlidingPanels from 'components/common/sliding-panel';
import CreateObjectPanel from './CreateObjectPanel';
import { useMediaQuery } from '@mui/material';
import { handleConvert } from '../utils';

const ObjectsContainer = ({ item, mainRefetch }) => {
  const { t } = useTranslation();
  const [isOpenCreateObj, setIsOpenCreateObj] = useState(false);
  const match = useMediaQuery('(max-width:550px)');
  const handleCreateObjModal = () => {
    setIsOpenCreateObj(!isOpenCreateObj);
  };

  const escFunction = useCallback((event) => {
    if (event.key === 'Escape') {
      setIsOpenCreateObj(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false);

    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };
  }, []);

  return (
    <div style={{ position: 'relative' }}>
      <Styles.ObjectCardSC>
        <Styles.NameContainer>
          <H4>{handleConvert(item.label)}</H4>
        </Styles.NameContainer>
        <Styles.Features>
          <div style={{ display: 'flex', width: '100%', flexWrap: 'wrap' }}>
            {item?.list.firewall_object_records?.map(
              (feature, index) =>
                index < 6 && (
                  <Styles.Feature key={index}>
                    <Icon name="check" />
                    <P>{feature.value}</P>
                  </Styles.Feature>
                ),
            )}
          </div>
          {item?.list?.count > 6 && (
            <Styles.SeeFeature onClick={handleCreateObjModal}>
              <Icon name="check" />
              <P>{t('vs/firewall.string44')}</P>
            </Styles.SeeFeature>
          )}
        </Styles.Features>
        <Styles.EditContainer>
          <Styles.EditButton onClick={handleCreateObjModal}>
            <Icon name="pencil" />
            <P>{t('vs/firewall.string45')}</P>
          </Styles.EditButton>
        </Styles.EditContainer>
      </Styles.ObjectCardSC>
      {isOpenCreateObj && (
        <SlidingPanels size={match ? 93 : 50} isOpen={isOpenCreateObj} isClose={setIsOpenCreateObj}>
          <CreateObjectPanel
            mainRefetch={mainRefetch}
            item={item}
            label={handleConvert(item?.label)}
            handleCloseModal={handleCreateObjModal}
          />
        </SlidingPanels>
      )}
    </div>
  );
};

export default ObjectsContainer;
